/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useState, useEffect } from "react";
import { DocumentEditContext } from "cms/documents/document-selector/context/document-edit-context";
import { useSnackbar } from "hooks/useSnackbar";
import { useDocuments } from "cms/documents/hooks/use-document";
import { TextFieldEditor } from "components/text-field-editor";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";

const DocumentRenamePanel = (props) => {

    const {
        fileNameExist,
        setFileNameExist,
        renameFileNameValid,
        setRenameFileNameValid,
        setLoading,
        loading,
    } = props;
    
    const { showSnackbar } = useSnackbar();

    const {
        setOpenEdit,
        selectedDocument,
        onDocumentRenamed,
        openRename,
        setOpenRename,
        isReplacing,
        isArchiving,
        setHasChanges
    } = useContext(DocumentEditContext);

    const { token } = useAuth();
    const { renameDocument } = useDocuments();
    
    const [fileName, setFileName] = useState(document?.file_name || "");

    useEffect(() => {
        setFileName(selectedDocument?.file_name);
    }, [selectedDocument]);

    const handleOpenRename = () => {
        setFileNameExist(false);
        setRenameFileNameValid(true);
        setOpenRename(true);
        setFileName(selectedDocument?.file_name || "");
    };

    const handleFilenameChange = (event) => {
        const value = event.target.value;
        setFileNameExist(false);
        setRenameFileNameValid(true);
        if (value) {
            setFileName(value);
        }
    };

    const handleRename = async () => {
        setLoading(true);
        try {
            const renamed_file_name = fileName;
            const { exist } = await SimpliCityAdminSDK.document.fileExist(token, fileName);
            if (exist) {
                setLoading(false);
                return setFileNameExist(exist);
            }
            const document = await renameDocument(selectedDocument?.guid, renamed_file_name);
            if (document) {
                onDocumentRenamed(document);
                showSnackbar("Document Renamed.");
                setOpenEdit(true);
                setHasChanges(true);
                setRenameFileNameValid(true);
                setOpenRename(false);
            } else {
                setRenameFileNameValid(false);
                showSnackbar("Document Rename Failed");
            }
        } catch (error) {
            setLoading(false);
            setHasChanges(false);
            // setRenameFileNameValid(false)
            // Check if the rename file name is invalid
            if (error.response?.data?.message === "InvalidRenameFileName") {
                return setRenameFileNameValid(false);
            }
            showSnackbar("Failed to rename document.");
        } finally {
            setLoading(false);
        }
    };

    const cancelEdit = () => {
        setOpenRename(false);
        setFileNameExist(false);
        setFileName(selectedDocument?.file_name || "");
        setRenameFileNameValid(true);
    };

    return (
        <div className="doc-file-name-container">
            
            <div className="doc-file-row">
                <div className="filename">Filename</div>
            </div>
            
            <TextFieldEditor
                containerClassName={"file-name-container"}
                currentTextValue={selectedDocument?.file_name}
                editMode={openRename}
                handleCancelEdit={cancelEdit}
                handleOpenEditor={handleOpenRename}
                handleSave={handleRename}
                handleTextValueChange={handleFilenameChange}
                loading={loading}
                newTextValue={fileName}
                showEditButton={!isArchiving && !isReplacing}
                fileNameExist={fileNameExist}
                renameFileNameValid={renameFileNameValid}
                // hideDisplay={true}
            />
        </div>
    );
};

export { DocumentRenamePanel };
